import React, { useCallback, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import { HELPER_TEXT } from 'common/constants/documents';
import CustomAutoSelectFolder from 'pages/Documents/components/AddFolderDialog/CustomAutoSelectFolder/CustomAutoSelectFolder';
import { processDocumentsInformation } from 'pages/Documents/utilities/processDocuments';
import { RequestFolderProps } from './RequestFolder.props';

const RequestFolder = ({
  formValues,
  setFormValues,
  currentDocuments,
  setOpenFolderDialog,
  newFolder,
  companyName,
}: RequestFolderProps) => {
  const currentDocumentsProcessed = useMemo(
    () => (currentDocuments ? processDocumentsInformation(currentDocuments) : { folders: [] }),
    [currentDocuments]
  );
  const updatedCurrentFolders = useMemo(
    () => [{ id: 0, name: 'No Option' }].concat(currentDocumentsProcessed.folders),
    [currentDocumentsProcessed]
  );

  const handleParentFolderChange = useCallback(
    (id: string | number) => {
      setFormValues({ ...formValues, folder: Number(id) });
    },
    [formValues, setFormValues]
  );

  return (
    <>
      <Typography variant="body1" gutterBottom style={{ fontWeight: 700 }}>
        Folder
      </Typography>
      <CustomAutoSelectFolder
        inputProps={{
          id: 'parent-folder',
          name: 'parent-folder',
          label: 'Select an option',
        }}
        onChange={handleParentFolderChange}
        data={updatedCurrentFolders}
        isAddNewFolderAtBottom
        setOpenFolderDialog={setOpenFolderDialog}
        newFolder={newFolder}
        helperText={HELPER_TEXT(companyName ?? '')}
        formValues={formValues}
      />
    </>
  );
};

export default RequestFolder;
